import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";

export function useListarEstadosCivis() {
  const fetchData = async () => {
    const LISTAR_ESTADOS_CIVIS = `dadoscomum/estados-civis`;
    const response = await instance.get(LISTAR_ESTADOS_CIVIS);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: ["listar_estados_civis"],
    refetchOnMount: true,
  });
  return query;
}
